export default {
  SHOW_SPINNER: '@YOLA_TEMPLATE_GALLERY/SHOW_SPINNER',
  HIDE_SPINNER: '@YOLA_TEMPLATE_GALLERY/HIDE_SPINNER',
};
